export const timeAndPeopleKey = 'timeAndPeople';
